import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'

import { Link } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { selectFullPageCoverStory } from './store/storiesReducer'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { CardMedia } from '@material-ui/core'
import api from './exhibitApi'


import './Ads.css'

function FullPageCover() {
  const story = useSelector(selectFullPageCoverStory)
  const id = story._id

  const [image, setImage] = useState('')

  useEffect(() => {
    ReactGA.event({
      category: 'View',
      action: 'Cover'
    })
  }, [story])


  useEffect(() => {
    async function getStory (id) {
      if(!id) return

      const data = await api.story().getById(id)
      const assetLength = data.assets.length

      //if for some reason we end up back on the cover, it felt weird to go directly into another slide so resetting here
      sessionStorage.setItem('slideIndex', 0)

      if(assetLength > 0) {
        const asset = data.assets[0]
        const image = api.image().imageUrl(asset.link, 320, 600, window.devicePixelRatio) 
        setImage(image)
      }
    }

    getStory(id)
  }, [id])



    return (
      <Card className="ad-container" elevation={0} square={true} >
        <CardContent>
            <div className="ad-wrapper">
          <CardMedia >
            <Link to={location => `${location.pathname}/program`} >
              <div className="ad-fullpage--320x600">
                <img src={ image } alt="" />
              </div>
            </Link>
          </CardMedia>
          </div>
        </CardContent>
      </Card>
    )
}

export default FullPageCover
